<ng-container *transloco="let t;">
  <form (submit)="onSubmitSlot()" *ngIf="ac !== null">

    <div class="p-grid">
        <div class="p-col-6">
            <h2>{{ t('common.labels.time_schedule') }}</h2>
        </div>
        <div class="p-col-6 p-text-right" *ngIf="inEdit !== true">
            <button [withRight]="'admin.' + mode + '.edit'" *ngIf="ac.not_yet_started || ac.is_template" pButton (click)="onEdit()" type="button" label="{{ t('common.labels.edit') }}" icon="pi pi-pencil" class="p-button-sm p-mb-2 autofocus"></button>
        </div>
        <div class="p-col-6 p-text-right" *ngIf="inEdit === true">
          <button pButton (click)="onCancel()" type="button" [disabled]="(submitting === true) ? true : null" label="{{ t('common.labels.cancel') }}" class="p-button-sm p-button-secondary p-button-outlined p-mb-2"></button>
          <button pButton *ngIf="submitting !== true" (click)="onSubmit()" type="button" icon="pi pi-check" label="{{ t('common.labels.save') }}" class="p-button-sm p-button-success p-mb-2 p-ml-2"></button>
          <button pButton *ngIf="submitting === true" type="button" icon="pi pi-spin pi-spinner" label="{{ t('common.labels.save') }}" class="p-button-sm p-button-success p-mb-2 p-ml-2" disabled="true"></button>
      </div>
    </div>

    <p *ngIf="ac.start_time === null">
      {{ t('ac_timing.based_on_time') }}<p-calendar name="timePicker" [(ngModel)]="timePicker" showTime="true" hourFormat="24" [timeOnly]="true" class="p-ml-2 p-mr-2" (ngModelChange)="timePickerChanged()" [disabled]="editSlot !== null"></p-calendar>
    </p>

    <div *ngIf="inEdit === true">
      <p-table [value]="editSlots" (onRowReorder)="onRowReorder($event)">

          <ng-template pTemplate="header">
              <tr>
                  <th style="width: 35px;"></th>
                  <th style="width: 100px;">{{ t('common.labels.time') }}</th>
                  <th style="width: 50px" class="p-text-center"><fa-icon [icon]="faStreetView" class="p-mr-2" pTooltip="{{ t('common.labels.candidate') }}"></fa-icon></th>
                  <th style="width: 50px" class="p-text-center"><fa-icon [icon]="faUsers" pTooltip="{{ t('common.labels.observer') }}"></fa-icon></th>
                  <th>{{ t('common.labels.name') }}</th>
                  <th style="width: 15%">{{ t('common.labels.duration') }}</th>
                  <th style="width: 120px;"></th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-slot let-index="rowIndex">
              <tr *ngIf="editSlot === null || editSlot !== slot" [pReorderableRow]="index" class="tr-hover" [class.break]="slot.type === 'break'" [pReorderableRowDisabled]="slot.showReorderHandle !== true">
                  <td>
                      <span *ngIf="slot.showReorderHandle === true" class="pi pi-bars" pReorderableRowHandle></span>
                  </td>
                  <td>
                    <div *ngIf="!slot.hasError('STARTTIME_TOO_EARLY')">
                      <span *ngIf="slot.time_real !== null">{{slot.time_real | amLocal | amDateFormat: 'HH:mm' }} {{ t('common.labels.oclock') }}</span>
                      <span *ngIf="slot.time_real === null && slot.time_minutes > 0">+ {{slot.time_minutes}} {{ t('common.labels.minutes') }}</span>
                    </div>
                    <div *ngIf="slot.hasError('STARTTIME_TOO_EARLY')">
                      <span *ngIf="slot.time_real !== null" pBadge value="!" severity="danger">{{slot.time_real | amLocal | amDateFormat: 'HH:mm' }} {{ t('common.labels.oclock') }}</span>
                      <span *ngIf="slot.time_real === null && slot.time_minutes > 0" pBadge value="!" severity="danger">+ {{slot.time_minutes}} {{ t('common.labels.minutes') }}</span>
                    </div>
                  </td>
                  <td>
                      <fa-icon *ngIf="slot.for_candidate === true" [icon]="faStreetView" pTooltip="{{ t('common.labels.candidate') }}"></fa-icon>
                  </td>
                  <td>
                      <fa-icon *ngIf="slot.for_observer === true" [icon]="faUsers" pTooltip="{{ t('common.labels.observer') }}"></fa-icon>
                  </td>
                  <td>
                    {{slot.name}}
                    <span *ngIf="slot.ratingGap > 0" class="rating-info"><br>{{ t('ac_timing.subsequent_rating') }} {{slot.ratingGap}} {{ t('common.labels.minutes') }}</span>
                    <ul *ngIf="slot.errors" class="errors">
                      <li *ngFor="let error of slot.errors">{{errorMessages[error]}}</li>
                    </ul>
                  </td>
                  <td class="nowrap">
                    <span *ngIf="!slot.hasError('DURATION_TOO_LONG')">{{slot.duration}} {{ t('common.labels.minutes') }}</span>
                    <span *ngIf="slot.hasError('DURATION_TOO_LONG')" pBadge value="!" severity="danger">{{slot.duration}} {{ t('common.labels.minutes') }}</span>
                  </td>
                  <td class="p-text-right buttons">
                      <button pButton (click)="onSlotEdit(slot)" type="button" icon="pi pi-pencil" class="p-ml-2"></button>
                      <button pButton (click)="onSlotDelete(slot)" type="button" icon="pi pi-trash" class="p-button-outlined danger-button p-ml-2" [disabled]="slot.type === 'exercisepart'"></button>
                  </td>
              </tr>
              <tr *ngIf="editSlot === slot">
                  <ng-template [ngTemplateOutlet]="tForm"></ng-template>
              </tr>
          </ng-template>

      </p-table>

      <p *ngIf="editSlot === null" class="p-mt-2">
        <button *ngIf="items.length > 0" pButton type="button" (click)="menu.toggle($event)" icon="pi pi-plus" label="{{ t('common.labels.add') }}" class="p-button-sm p-mb-2 p-ml-2"></button>
        <p-menu #menu [popup]="true" [model]="items"></p-menu>
      </p>

    </div>

    <div class="p-grid" *ngIf="inEdit !== true && hasSlots()">
        <div class="p-col-6">
            <h3>{{ t('common.labels.candidate') }}</h3>
            <ul>
                <li *ngFor="let slot of slots.candidate" [ngClass]="{'break': slot.type === 'break'}">
                  <i [ngClass]="'pi ' + slot.icon + ' p-mr-2'"></i>
                  <span class="time" *ngIf="slot.time !== null">{{ slot.time | amLocal | amDateFormat: 'HH:mm' }} {{ t('common.labels.oclock') }}</span>
                  {{ slot.name }}
                </li>
            </ul>
        </div>
        <div class="p-col-6">
            <h3>{{ t('common.labels.observer') }}</h3>
            <ul>
                <li *ngFor="let slot of slots.observer" [ngClass]="{'break': slot.type === 'break'}">
                  <i [ngClass]="'pi ' + slot.icon + ' p-mr-2'"></i>
                  <span class="time" *ngIf="slot.time !== null">{{ slot.time | amLocal | amDateFormat: 'HH:mm' }} {{ t('common.labels.oclock') }}</span>
                  {{ slot.name }}
                </li>
            </ul>
        </div>
    </div>

    <p *ngIf="(inEdit !== true && !hasSlots()) || (inEdit === true && editSlots.length === 0)">{{ t('common.texts.no_time_schedule') }}</p>

    <ng-container *ngIf="ac.isGroupAc()">
      <hr />
      <p>{{ t('ac_timing.hint_group_acs') }}</p>
    </ng-container>


    <ng-template #tForm>
      <td></td>
      <td></td>
      <td class="p-text-center">
        <div class="p-field-checkbox p-mb-0">
          <p-checkbox [formControl]="form.get('relevance.for_candidate')" binary="true"></p-checkbox>
        </div>
        <app-form-error [control]="form.get('relevance')" [label]="t('common.labels.please_choose_candidate_observer')" [inline]="true"></app-form-error>
      </td>
      <td class="p-text-center">
        <div class="p-field-checkbox p-mb-0">
          <p-checkbox [formControl]="form.get('relevance.for_observer')" binary="true"></p-checkbox>
        </div>
        <app-form-error [control]="form.get('relevance')" [label]="t('common.labels.please_choose_candidate_observer')" [inline]="true"></app-form-error>
      </td>
      <td>
        <app-form-control [cid]="'name'" [control]="form.get('name')" [type]="'input'"></app-form-control>
      </td>
      <td>
        <app-form-control [cid]="'duration'" [control]="form.get('duration')" [type]="'input'"></app-form-control>
      </td>
      <td style="text-align: right">
        <app-form-buttons [icons]="false" (cancelled)="onCancelSlot()"></app-form-buttons>
      </td>
    </ng-template>

  </form>

  <app-inherit-dialog
    [title]="t('common.labels.save')"
    [mode]="'template'"
    [(visible)]="inheritVisible"
    (okClicked)="saveSlots($event)"
  ></app-inherit-dialog>

</ng-container>
